import React from "react";
import "./volunteer.css";
import { Link } from "react-router-dom";

function VolunteerTraining() {
  return (
    <div className="volunteer-training-page">

      {/* Banner Section */}
      <section className="volunteer-banner-section">
        <img src="/trainingsbanner.png" alt="Volunteer Banner" className="volunteer-banner-img" />
        <div className="volunteer-banner-overlay">
          <h1>Volunteer Training Program</h1>
          <p>
            Join our Volunteer Training Program to develop skills, gain experience, and actively contribute to meaningful community initiatives.
          </p>
        </div>
      </section>

      {/* Description Section */}
      <section className="volunteer-description-section">
        <div className="volunteer-text">
          <h2>About Volunteer Training Programm</h2>
<p>
  The Volunteer Training Program equips participants with the skills to promote eye care awareness, support eye camps, 
  assist in early detection initiatives, and contribute to community eye health programs. Volunteers gain practical experience, 
  leadership skills, and the opportunity to make a lasting impact on preventing avoidable blindness.
</p>

        </div>
        <div className="volunteer-image">
          <img src="/community.png" alt="Volunteer Training" />
        </div>
      </section>

      {/* Recent Program Gallery */}
      <section className="volunteer-held-programme-wrapper">
        <div className="volunteer-held-programme-header">
          <h1>Recent Volunteer Training Sessions</h1>
          <p>
            Browse through our recent volunteer workshops and field activities, where participants learned hands-on techniques to contribute effectively to community projects.
          </p>
        </div>

        <div className="volunteer-held-programme-gallery">
          <img src="/vol1.png" alt="Volunteer Training 1" />
          <img src="/vol2.jpg" alt="Volunteer Training 2" />
          <img src="/vol3.jpg" alt="Volunteer Training 3" />
          <img src="/vol4.jpg" alt="Volunteer Training 4" />
          <img src="/vol5.jpg" alt="Volunteer Training 5" />
          <img src="/vol61.png" alt="Volunteer Training 61" />
          <img src="/vol7.jpg" alt="Volunteer Training 7" />
          <img src="/vol8.jpg" alt="Volunteer Training 8" />
          <img src="/vol9.jpg" alt="Volunteer Training 9" />
          <img src="/vol10.jpg" alt="Volunteer Training 10" />
          <img src="/vol6.jpg" alt="Volunteer Training 6" />
           {/* <img src="/vol12.jpg" alt="Volunteer Training 12" /> */}
        </div>
      </section>

      {/* Footer Section */}
      <section className="volunteer-footer-section">
        <div className="volunteer-footer-content">
          <h2>Be the Change</h2>
          <p>
            Join us in empowering communities through active volunteer participation. Your time and effort can create a lasting difference.
          </p>
          <Link to="/contactus">
            <button className="volunteer-footer-button">Get Involved</button>
          </Link>
        </div>
      </section>

    </div>
  );
}

export default VolunteerTraining;
